export default __webpack_public_path__ + "static/media/close-icon.0e221e22.svg";